import type { ComponentProps, ReactNode } from 'react';
import { LandingV2 } from '@/features/home/components/landing-v2/landing-v2';

type HomeViewProps = ComponentProps<typeof LandingV2> & { children?: ReactNode };

export function HomeView({ children, ...landing }: HomeViewProps) {
    return <div className="homepage"><LandingV2 {...landing} />{children}</div>;
}
